import { useState } from "react";
import "./editorialForms.css";

const categories = [
  { id: "technology", name: "Tecnologia" },
  { id: "design", name: "Design" },
  { id: "marketing", name: "Marketing" },
  { id: "writing", name: "Redação" },
  { id: "translation", name: "Tradução" },
  { id: "construction", name: "Construção" },
  { id: "cleaning", name: "Limpeza" },
  { id: "repair", name: "Reparos" },
  { id: "plumbing", name: "Encanamento" },
  { id: "electrical", name: "Elétrica" },
  { id: "teaching", name: "Aulas" },
  { id: "health", name: "Saúde" },
  { id: "legal", name: "Jurídico" },
  { id: "accounting", name: "Contabilidade" },
  { id: "other", name: "Outros" },
];

const priceTypes = [
  { id: "fixed", name: "Preço fixo" },
  { id: "hourly", name: "Por hora" },
  { id: "negotiable", name: "A combinar" },
  { id: "quote", name: "Orçamento" },
];

const experienceLevels = [
  { id: "beginner", name: "Iniciante" },
  { id: "intermediate", name: "Intermediário" },
  { id: "expert", name: "Especialista" },
];

export default function JobServiceForm({ data, onChange }) {
  const [skillInput, setSkillInput] = useState("");

  const handleAddSkill = () => {
    if (skillInput.trim()) {
      onChange({
        ...data,
        skills: [...(data?.skills || []), skillInput.trim()],
      });
      setSkillInput("");
    }
  };

  const handleRemoveSkill = (index) => {
    onChange({
      ...data,
      skills: (data?.skills || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form job_service_form">
      <div className="editorial_form_section">
        <label>
          Título do Serviço <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Desenvolvimento de Sites, Aulas de Inglês..."
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>Descrição do Serviço</label>
        <textarea
          placeholder="Descreva seu serviço em detalhes, experiência, diferenciais..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={4}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Categoria</label>
          <select
            value={data?.category || ""}
            onChange={(e) => onChange({ ...data, category: e.target.value })}
          >
            <option value="">Selecione</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>Subcategoria</label>
          <input
            type="text"
            placeholder="Ex: React, WordPress..."
            value={data?.subcategory || ""}
            onChange={(e) => onChange({ ...data, subcategory: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Preço</label>
          <select
            value={data?.priceType || ""}
            onChange={(e) => onChange({ ...data, priceType: e.target.value })}
          >
            <option value="">Selecione</option>
            {priceTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        {(data?.priceType === "fixed" || data?.priceType === "hourly") && (
          <div className="editorial_form_section">
            <label>Valor (R$)</label>
            <input
              type="number"
              placeholder="0.00"
              value={data?.price || ""}
              onChange={(e) =>
                onChange({ ...data, price: parseFloat(e.target.value) || 0 })
              }
              min="0"
              step="0.01"
            />
          </div>
        )}

        <div className="editorial_form_section">
          <label>Experiência</label>
          <select
            value={data?.experience || ""}
            onChange={(e) => onChange({ ...data, experience: e.target.value })}
          >
            <option value="">Selecione</option>
            {experienceLevels.map((level) => (
              <option key={level.id} value={level.id}>
                {level.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Localização</label>
        <input
          type="text"
          placeholder="Cidade, Estado"
          value={data?.location || ""}
          onChange={(e) => onChange({ ...data, location: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isRemote"
            checked={data?.isRemote || false}
            onChange={(e) => onChange({ ...data, isRemote: e.target.checked })}
          />
          <label htmlFor="isRemote">Atendo remotamente</label>
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Disponibilidade</label>
        <input
          type="text"
          placeholder="Ex: Seg-Sex 9h-18h, Disponível imediatamente..."
          value={data?.availability || ""}
          onChange={(e) => onChange({ ...data, availability: e.target.value })}
        />
      </div>

      <div className="editorial_form_section">
        <label>
          Habilidades
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddSkill}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: JavaScript, Photoshop, Eletricista..."
          value={skillInput}
          onChange={(e) => setSkillInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddSkill()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.skills || []).map((skill, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveSkill(i)}
              style={{ cursor: "pointer" }}
            >
              {skill} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Trabalhos Concluídos</label>
          <input
            type="number"
            placeholder="0"
            value={data?.completedJobs || ""}
            onChange={(e) =>
              onChange({
                ...data,
                completedJobs: parseInt(e.target.value) || 0,
              })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Avaliação (1-5)</label>
          <input
            type="number"
            placeholder="4.5"
            value={data?.rating || ""}
            onChange={(e) =>
              onChange({ ...data, rating: parseFloat(e.target.value) || 0 })
            }
            min="0"
            max="5"
            step="0.1"
          />
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z" />
        </svg>
        <span>
          Adicione fotos do seu trabalho para mostrar seu portfólio aos clientes.
        </span>
      </div>
    </div>
  );
}
